import { render, staticRenderFns } from "./NwxCheckbox.vue?vue&type=template&id=6ce72010&scoped=true"
import script from "./NwxCheckbox.vue?vue&type=script&lang=js"
export * from "./NwxCheckbox.vue?vue&type=script&lang=js"
import style0 from "./NwxCheckbox.vue?vue&type=style&index=0&id=6ce72010&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce72010",
  null
  
)

export default component.exports